import { render, staticRenderFns } from "./NsAnimateHeight.vue?vue&type=template&id=00b33711&scoped=true&"
import script from "./NsAnimateHeight.vue?vue&type=script&lang=js&"
export * from "./NsAnimateHeight.vue?vue&type=script&lang=js&"
import style0 from "./NsAnimateHeight.vue?vue&type=style&index=0&id=00b33711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b33711",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b33711')) {
      api.createRecord('00b33711', component.options)
    } else {
      api.reload('00b33711', component.options)
    }
    module.hot.accept("./NsAnimateHeight.vue?vue&type=template&id=00b33711&scoped=true&", function () {
      api.rerender('00b33711', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsAnimateHeight.vue"
export default component.exports